import { ReadOnlyTextField } from '../../../garvan-react/Components/ReadOnlyTextField'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  RadioGroup,
  Select,
  Stack,
} from '@mui/material'
import { DeleteForever, TrendingUp } from '@mui/icons-material'
import * as React from 'react'
import { useMemo, useState } from 'react'
import { listFromCodes } from '../../../Functions/ListItemGenerator'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useScreenContext } from '../../../Contexts/Modules/HealthModule/SelectedScreenModule'
import PageSection from '../../../Constants&Theme/PageSection'
import { useParams } from 'react-router-dom'
import { useStuartGet } from '../../../APIs/Hooks/PhpAPIHooks'
import { stackGap } from '../../../Constants&Theme/Spacing'
import ConfirmDeleteDialog from './ConfirmDeleteDialog'
import ConfirmReleaseDialog from './ConfirmReleaseDialog'

export enum screenInfoModals {
  RELEASE,
  DELETE,
}

function ScreenInfo() {
  const { screen_id } = useParams()
  const { loginConfig, loadingConfig } = useUserContext()
  const { screenQuery, editable } = useScreenContext()

  const [open, setOpen] = useState<screenInfoModals | undefined>(undefined)
  const holdings = listFromCodes(loginConfig, 'KV-Holdings', loadingConfig)
  const collectionsQuery = useStuartGet(
    ['/screen/getScreenCollections.php', `?ScreenID=${screen_id}`],
    !!screen_id,
  )
  const billingStatus = useMemo(() => {
    let status = 'NA'
    if (collectionsQuery.data?.Collections) {
      collectionsQuery.data?.Collections.forEach((col: any) => {
        if (col.Rebill === 'Y') {
          status = 'UB'
        }
      })
    }
    return status
  }, [collectionsQuery.data])

  return (
    <PageSection
      title={`Screen Request: ${screen_id}`}
      loading={collectionsQuery.isLoading}
      leftDecorator={
        <Button
          variant="contained"
          color="error"
          disabled={!editable}
          onClick={() => setOpen(screenInfoModals.DELETE)}
          startIcon={<DeleteForever />}
        >
          Delete
        </Button>
      }
      rightDecorator={
        <Button
          variant="contained"
          color="success"
          disabled={!editable || collectionsQuery.data?.Collections?.length < 1}
          onClick={() => setOpen(screenInfoModals.RELEASE)}
          startIcon={<TrendingUp />}
          sx={{ ml: 'auto' }}
        >
          Release
        </Button>
      }
    >
      <Stack
        gap={stackGap.col}
        width={1}
      >
        <Stack
          gap={stackGap.row}
          direction={'row'}
          width={1}
        >
          <ReadOnlyTextField
            label="Request Name"
            value={screenQuery.data?.Name ?? ''}
            fullWidth
          />
          <ReadOnlyTextField
            label="Collection Status"
            value={getCodeSetLabelLookup(
              loginConfig,
              ['ScreenCollectionStatusID'],
              screenQuery.data?.CollectionStatus,
            )}
            fullWidth
          />
        </Stack>
        <FormControl fullWidth>
          <InputLabel>Holdings</InputLabel>
          <Select
            label="Holdings"
            multiple
            readOnly
            value={screenQuery.data?.Holdings || []}
            IconComponent={() => <div />}
            renderValue={(holdings) => (
              <RadioGroup
                sx={{
                  flexWrap: 'wrap',
                  gap: 1 / 2,
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                {holdings.map((value) => (
                  <Box>
                    <Chip
                      key={value}
                      label={getCodeSetLabelLookup(
                        loginConfig,
                        ['KV-Holdings'],
                        value,
                      )}
                    />
                  </Box>
                ))}
              </RadioGroup>
            )}
          >
            {holdings}
          </Select>
        </FormControl>
      </Stack>
      <ConfirmDeleteDialog
        open={open}
        setOpen={setOpen}
      />
      <ConfirmReleaseDialog
        open={open}
        setOpen={setOpen}
        billingStatus={billingStatus}
      />
    </PageSection>
  )
}

export default ScreenInfo
